import React, { useContext, useEffect, useState } from "react";
import "./HomeMagasin.css";
import DefaulteImage from "../../Utilisateure/visiteur/DefaulteImage.jpeg";
import { Link } from "react-router-dom";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import AfficheArticleInMagasin from "../../../Services/Magasin/AfficheArticleInMagasin";
import { MagasinContext } from "../../../Context/MagasinContext";
import FilterMagasin from "./mobile-magasin/FilterMagasin";
import axios from "axios";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import PanierLengVisiteur from "../../../Services/Panier/PanierLeng";/* ─── Commission resolution helper ─── */
function resolveCommission(
  rules: any[],
  myMagasinName?: string,
  productMagasinName?: string
): number {
  const glob = rules.find((r: any) => r.commission_type === 'global');
  return glob ? parseFloat(glob.commission_value) || 0 : 0;
}

function calcPriceWithCommission(price: any, commissionPct: number): string {
  const p = parseFloat(String(price).replace(',', '.'));
  if (isNaN(p)) return '0.00';
  const total = p + (p * commissionPct / 100);
  const truncated = Math.floor(total * 100 + 0.00001) / 100;
  return truncated.toFixed(2);
}

/* ─── types ──────────────────────────────────────────────── */
type Coords   = { latitude: number; longitude: number };
type QtyMap   = { [id: number]: number };
type AddedMap = { [id: number]: boolean };

/* ═══════════════════════════════════════════════════════════
   COLIS TOAST
═══════════════════════════════════════════════════════════ */
function ColisToast({ msg, active, onClose }:
  { msg: string; active: boolean; onClose: () => void }
) {
  useEffect(() => { const t = setTimeout(onClose, 3000); return () => clearTimeout(t); }, [onClose]);
  return (
    <div className={`hm2-toast ${active ? "hm2-toast-on" : "hm2-toast-off"}`}>
      <i className={`bi ${active ? "bi-box-seam-fill" : "bi-box-seam"}`} />
      <span>{msg}</span>
      <button onClick={onClose} className="hm2-toast-x"><i className="bi bi-x" /></button>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   COLIS BANNER
═══════════════════════════════════════════════════════════ */
function ColisBanner({ active, loading, onToggle }:
  { active: boolean; loading: boolean; onToggle: () => void }
) {
  return (
    <button
      className={`hm2-colis ${active ? "hm2-colis-on" : ""}`}
      onClick={onToggle}
      disabled={loading}
    >
      <span className="hm2-colis-icon">
        {loading
          ? <span className="hm2-spin-xs" />
          : <i className={`bi ${active ? "bi-box-seam-fill" : "bi-box-seam"}`} />}
      </span>
      <span className="hm2-colis-body">
        <span className="hm2-colis-title">Réception des colis</span>
        <span className="hm2-colis-sub">
          {active ? "Livraisons activées" : "Livraisons désactivées"}
        </span>
      </span>
      <span className={`hm2-colis-badge ${active ? "hm2-badge-on" : "hm2-badge-off"}`}>
        {active ? "Actif" : "Inactif"}
      </span>
      <span className={`hm2-sw ${active ? "hm2-sw-on" : ""}`}>
        <span className="hm2-sw-knob" />
      </span>
    </button>
  );
}

/* ═══════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════ */
export function HomeMagasin() {
  const ctx         = useContext(MagasinContext);
  const MagasinId   = localStorage.getItem("MagasinId");
  const MagasinName = localStorage.getItem("MagasinName") || ctx.id?.NomMagasin || ctx.id?.Nom_magasin;
  const id          = MagasinId || ctx.id?.id;

  const CATS = [
    "CATERPILLAR","VOLVO","JCB","CUMMINS","DOOSAN",
    "HYUNDAI","FIAT","ESCO","TOYOTA","ATLAS","VIBROMAX","LOMBARDINI",
  ];

  /* ═══════════════════════════════════════════════════════
     COLIS STATE
     ─────────────────────────────────────────────────────
     Backend values:
       'reception'     → colis ON  (active)
       'non_reception' → colis OFF (inactive)

     GET  /magasins/{id}/colis          → read current status
     POST /magasins/{id}/colis  { status: 'reception' | 'non_reception' }
  ═══════════════════════════════════════════════════════ */
  const [colisOn, setColisOn] = useState(false);
  const [colisLd, setColisLd] = useState(false);
  const [toast,   setToast]   = useState<{ show: boolean; msg: string; on: boolean }>(
    { show: false, msg: "", on: false }
  );

/* ── fetch current colis status & en-compte suppliers on mount ── */
  const [enCompteSuppliers, setEnCompteSuppliers] = useState<any[]>([]);
  const [isFournisseur, setIsFournisseur]         = useState(
    localStorage.getItem('en_compte_is_fournisseur') === '1'
  );

  useEffect(() => {
    if (!id) return;
    axios
      .get(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/colis`)
      .then(r => {
        // 1 = active (selected), 0 = inactive (deselected)
        setColisOn(r.data?.status == 1);
      })
      .catch(() => {});

    axios
      .get(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/check-en-compte`)
      .then(r => {
        if (r.data?.magasins) {
          setEnCompteSuppliers(r.data.magasins);
        }
        // Persist and apply is_fournisseur flag
        const isFourn = !!r.data?.is_fournisseur;
        setIsFournisseur(isFourn);
        localStorage.setItem('en_compte_is_fournisseur', isFourn ? '1' : '0');

        // Real-time solde sync: refresh stored solde from latest API data
        const activeId = localStorage.getItem('en_compte_supplier_id');
        if (activeId && Array.isArray(r.data?.magasins)) {
          const active = r.data.magasins.find((m: any) => String(m.magasin_id) === activeId);
          if (active) {
            localStorage.setItem('en_compte_solde', String(active.solde ?? '0'));
          }
        }
      })
      .catch(() => {});
  }, [id]);

/* ── toggle colis on / off ───────────────────────────── */
const toggleColis = async () => {
  if (colisLd) return;

  const next = !colisOn;  // next state
  const prev = colisOn;   // backup for rollback

  setColisLd(true);
  setColisOn(next);       // optimistic UI update

  try {
    const fd = new FormData();
    fd.append("status", next ? "1" : "0");  // 1 = active, 0 = inactive

    await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/colis`,
      fd
    );

    setToast({
      show: true,
      msg:  next ? "Réception des colis activée" : "Réception des colis désactivée",
      on:   next,
    });

  } catch (error) {
    setColisOn(prev);   // rollback on error
    setToast({ show: true, msg: "Erreur lors de la mise à jour.", on: false });
    console.error("Toggle colis error:", error);
  } finally {
    setColisLd(false);
  }
};

  /* ── commission rules ─────────────────────────────────── */
  const [commissionRules, setCommissionRules] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`)
      .then(r => setCommissionRules(r.data || []))
      .catch(() => setCommissionRules([]));
  }, []);

  const getCommission = (productMagasinName: string): number => {
    return resolveCommission(commissionRules, MagasinName || '', productMagasinName || '');
  };
  /* ── cart ──────────────────────────────────────────────── */
  const [qtyMap, setQtyMap]     = useState<QtyMap>({});
  const [added,  setAdded]      = useState<AddedMap>({});
  const [addingId, setAddingId] = useState<number | null>(null);

  const getQty = (aid: number) => qtyMap[aid] ?? 1;
  const chQty  = (aid: number, d: number) =>
    setQtyMap(p => ({ ...p, [aid]: Math.max(1, (p[aid] ?? 1) + d) }));
  const setQty = (aid: number, v: string) => {
    const n = parseInt(v);
    if (!isNaN(n) && n >= 1) setQtyMap(p => ({ ...p, [aid]: n }));
  };

  const addToCart = async (pro: any) => {
    const aid   = pro.IdArticle ?? pro.id;
    const qty   = getQty(aid);
    const magId = MagasinId ?? "";
    setAddingId(aid);
    try {
      const fd = new FormData();
      fd.append("IdUtilisateur",   magId);
      fd.append("TypeUtilisiteur", "magasins");
      fd.append("IdArticle",       String(aid));
      fd.append("RefArticle",      pro.RefArticle);
      fd.append("Designation",     pro.Designation);
      fd.append("Image",           pro.urlImage || DefaulteImage);
      const proMagasin = pro.NomMagasin || pro.Nom_magasin || pro.nom_Magasin || pro.seller || "";
      const basePrice = pro.PrixNetHT || pro.PrixVenteArticleTTC || pro.prix_ht_1_magasin || pro.prix || pro.price || 0;
      const finalPrice = calcPriceWithCommission(basePrice, getCommission(proMagasin));
      fd.append("price",           finalPrice);
      fd.append("quantity",        String(qty));
      fd.append("NomMagasin",      pro.NomMagasin || MagasinName || "");
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier`, fd);
      localStorage.setItem('cartExpiration', String(Date.now() + 50 * 60 * 1000)); // 50 minutes
      setAdded(p => ({ ...p, [aid]: true }));
      setTimeout(() => setAdded(p => ({ ...p, [aid]: false })), 1800);
      await PanierLengVisiteur(magId, "magasins").GetLenPanier();
      // Signal the sidebar to refresh its panier count
      window.dispatchEvent(new Event("panier-updated"));
    } catch (e) { console.error(e); }
    finally { setAddingId(null); }
  };

  /* ── search (HomeVisiteur logic) ──────────────────────── */
  const [searchInput, setSearchInput] = useState("");
  const [search,      setSearch]      = useState("");
  const [refs,        setRefs]        = useState<any[]>([]);

  const [products,    setProducts]    = useState<ArticleInfo[]>([]);
  const [alldata,     setAlldata]     = useState<ArticleInfo[]>([]);
  const [myProducts,  setMyProducts]  = useState<ArticleInfo[]>([]);
  const [page,        setPage]        = useState(1);
  const [totalPages,  setTotalPages]  = useState(1);
  const [loading,     setLoading]     = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const [selCat,     setSelCat]     = useState<string>("Tous");
  const [isCatMode,  setIsCatMode]  = useState(false);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [otherCategory, setOtherCategory]   = useState("");
  const visibleCats = CATS.slice(0, 6);
  const [shopFilter, setShopFilter] = useState("tout les produits");
  const [distFilter, setDistFilter] = useState("");
  const [userLoc,    setUserLoc]    = useState<Coords | null>(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [screenW,    setScreenW]    = useState(window.innerWidth);
  const [filterMoinsCher,  setFilterMoinsCher]  = useState(false);
  const [filterDisponible, setFilterDisponible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("userLocation");
    if (saved) setUserLoc(JSON.parse(saved));
  }, []);

  useEffect(() => {
    const fn = () => setScreenW(window.innerWidth);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  useEffect(() => {
    if (distFilter === "par parent") {
      navigator.geolocation?.getCurrentPosition(
        p => setUserLoc({ latitude: p.coords.latitude, longitude: p.coords.longitude }),
        () => {}
      );
    } else { setUserLoc(null); }
  }, [distFilter]);

  const initialProductsRef = React.useRef<ArticleInfo[]>([]);
  const initialTotalPagesRef = React.useRef<number>(1);

  const fetchProducts = async (p = 1, append = false, sortParam = '', disponibleParam = false, magName = '') => {
    try {
      append ? setLoadingMore(true) : setLoading(true);
      const res = await AfficheArticleInMagasin().getAnly20Article(p, sortParam, disponibleParam, magName);
      const fetched = res.data.data ?? [];
      setProducts(prev => append ? [...prev, ...fetched] : fetched);
      setPage(res.data.current_page);
      setTotalPages(res.data.total_pages);
      if (!append) setAlldata(fetched);
      if (!append && p === 1 && sortParam === '' && !disponibleParam && !magName && initialProductsRef.current.length === 0 && fetched.length > 0) {
        initialProductsRef.current = fetched;
        initialTotalPagesRef.current = res.data.total_pages;
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); setLoadingMore(false); }
  };



  useEffect(() => {
    if (id) {
      AfficheArticleInMagasin().getArticleMagasin(id)
        .then(res => {
          let data = res.data || [];
          if (!Array.isArray(data) && res.data.data) data = res.data.data;
          setMyProducts(data);
        })
        .catch(err => console.error("Error fetching my products: ", err));
    }
  }, [id]);

  const initialFetchDone = React.useRef(false);
  const prevShopFilter = React.useRef(shopFilter);

  /* ── Re-fetch when filter buttons or sub-tab changes ── */
  useEffect(() => {
    const sort = filterMoinsCher ? 'price_asc' : '';
    const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
    const activeCat = (selCat && selCat !== "Tous") ? selCat : '';
    if (search.trim() !== "" || activeCat !== "") {
      fetchRefs(search.trim(), 1, false, sort, filterDisponible, magName, selCat);
    } else {
      fetchProducts(1, false, sort, filterDisponible, magName);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterMoinsCher, filterDisponible, shopFilter]);

  const resetToDefault = () => {
    setSearch(""); setSearchInput(""); setSelCat("Tous"); setRefs([]); setPage(1);
    setIsCatMode(false);
    localStorage.removeItem("SaveTape");
    const sort = filterMoinsCher ? 'price_asc' : '';
    const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
    if (initialProductsRef.current.length > 0 && shopFilter !== "Mes Produits" && !filterMoinsCher && !filterDisponible) {
      setProducts(initialProductsRef.current);
      setAlldata(initialProductsRef.current);
      setTotalPages(initialTotalPagesRef.current);
      setLoading(false);
    } else {
      fetchProducts(1, false, sort, filterDisponible, magName);
    }
  };

  const handleClearCategory = () => {
    setSelCat("Tous");
    setIsCatMode(false);
    setOtherCategory("");
    const activeSearch = searchInput.trim() || search.trim();
    const sort = filterMoinsCher ? 'price_asc' : '';
    const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
    if (activeSearch !== "") {
      fetchRefs(activeSearch, 1, false, sort, filterDisponible, magName, "Tous");
    } else {
      resetToDefault();
    }
  };

  const fetchRefs = async (
    term: string,
    p = 1,
    append = false,
    sortParam = '',
    disponibleParam = false,
    magName = '',
    catParam = selCat
  ) => {
    const activeCat = (catParam && catParam !== "Tous") ? catParam : '';
    const queryToUse = term.trim();
    if (!queryToUse && !activeCat) { setRefs([]); setTotalPages(1); setPage(1); return; }
    try {
      append ? setLoadingMore(true) : setLoading(true);
      const r = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/search-articles`,
        {
          params: {
            q: queryToUse || undefined,
            categorie: activeCat || undefined,
            page: p,
            perPage: 20,
            sort: sortParam || undefined,
            disponible: disponibleParam ? '1' : undefined,
            magasinName: magName || undefined
          }
        });
      setRefs(prev => append ? [...prev, ...r.data.data] : r.data.data);
      setPage(r.data.current_page);
      setTotalPages(r.data.total_pages);
    } catch (e) { console.error(e); }
    finally { setLoading(false); setLoadingMore(false); }
  };

  const fetchCat = async (cat: string, p = 1, append = false) => {
    let targetCat = cat;
    if (!append && (selCat === cat || cat === "Tous")) {
      handleClearCategory();
      return;
    } else {
      setSelCat(cat);
    }
    const sort = filterMoinsCher ? 'price_asc' : '';
    const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
    fetchRefs(searchInput.trim(), p, append, sort, filterDisponible, magName, targetCat);
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchInput(val);
    if (val.trim() === "") {
      if (selCat && selCat !== "Tous") {
        setSearch("");
        const sort = filterMoinsCher ? 'price_asc' : '';
        const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
        fetchRefs("", 1, false, sort, filterDisponible, magName, selCat);
      } else {
        resetToDefault();
      }
    }
  };

  const triggerSearch = () => {
    const val = searchInput.trim();
    setSearch(val); setRefs([]); setPage(1);
    const sort = filterMoinsCher ? 'price_asc' : '';
    const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
    fetchRefs(val, 1, false, sort, filterDisponible, magName, selCat);
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") triggerSearch();
  };

  const handleSuivant = () => {
    if (page >= totalPages) return;
    const next = page + 1;
    const sort = filterMoinsCher ? 'price_asc' : '';
    const magName = shopFilter === "Mes Produits" ? MagasinName || '' : '';
    const activeSearch = searchInput.trim() || search.trim();
    const activeCat = (selCat && selCat !== "Tous") ? selCat : '';
    if (activeSearch !== "" || activeCat !== "") {
      fetchRefs(activeSearch, next, true, sort, filterDisponible, magName, selCat);
    } else {
      fetchProducts(next, true, sort, filterDisponible, magName);
    }
  };

  const hasMore = page < totalPages;

  useEffect(() => {
    const saved = localStorage.getItem("SaveTape");
    if (!saved || !saved.trim()) return;
    setSearch(saved); setSearchInput(saved);
    if (CATS.includes(saved)) fetchCat(saved);
    else fetchRefs(saved, 1, false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dist = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const list = search.trim() !== "" ? refs : products;

  /* ── card ─────────────────────────────────────────────── */
  const Card = ({ pro, linkTo }: { pro: any; linkTo: string }) => {
    const aid      = pro.IdArticle ?? pro.id;
    const qty      = getQty(aid);
    const isAdded  = added[aid] ?? false;
    const isAdding = addingId === aid;
    const noStock  = (pro.Quantité ?? pro.Qte ?? 0) <= 0;
    const img     = pro.urlImage || DefaulteImage;
    const proMagasin = pro.NomMagasin || pro.Nom_magasin || pro.nom_Magasin || "";
    const isMyProduct = Boolean(
      MagasinName && proMagasin && MagasinName.trim().toLowerCase() === proMagasin.trim().toLowerCase()
    );

    return (
      <div className={`hm2-card${noStock ? " hm2-card-out" : ""}`}>
        <div className="hm2-img">
          <img src={img} alt={pro.Designation} className={noStock ? "hm2-img-grey" : ""} />
          <span className="hm2-brand">{pro.NomMarque || "Pièce"}</span>
          {noStock
            ? <div className="hm2-stock hm2-stock-out"><i className="bi bi-x-circle-fill" /> Stock épuisé</div>
            : <div className="hm2-stock hm2-stock-in">
                {userLoc && pro.latitude && pro.longitude ? (
                  <><i className="bi bi-geo-alt-fill" />{dist(userLoc.latitude, userLoc.longitude, parseFloat(pro.latitude), parseFloat(pro.longitude)).toFixed(1)} km</>
                ) : (
                  <><i className="bi bi-check-circle-fill" />En stock</>
                )}
              </div>
          }
          {!noStock && (
            <button className="hm2-wish" onClick={e => e.preventDefault()} aria-label="Favoris">
              <i className="bi bi-suit-heart" />
            </button>
          )}
        </div>
        <div className="hm2-body">
          <div className="hm2-stars">
            {[...Array(5)].map((_, i) => <i key={i} className="bi bi-star-fill hm2-star" />)}
            <span className="hm2-rating">(4.8)</span>
          </div>
          <Link className="hm2-link" to={linkTo}>
            <p className="hm2-title">
              {pro.Designation}{pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
            </p>
          </Link>
          <p className="hm2-ref">Réf : {pro.RefArticle}</p>
          <p className="hm2-price">
            {calcPriceWithCommission(pro?.PrixNetHT || pro?.PrixVenteArticleTTC || pro?.prix_ht_1_magasin || pro?.prix || pro?.price || 0, getCommission(proMagasin))}
            <span className="hm2-cur"> MAD</span>
          </p>
          {!noStock && !isMyProduct && (
            <div className="hm2-cart">
              <div className="hm2-qty">
                <button className="hm2-qbtn" onClick={e => { e.preventDefault(); chQty(aid, -1); }}>−</button>
                <input className="hm2-qinput" type="number" min={1} value={qty}
                  onClick={e => e.preventDefault()}
                  onChange={e => { e.preventDefault(); setQty(aid, e.target.value); }} />
                <button className="hm2-qbtn" onClick={e => { e.preventDefault(); chQty(aid, +1); }}>+</button>
              </div>
              <button
                className={`hm2-add${isAdded ? " hm2-added" : ""}${isAdding ? " hm2-adding" : ""}`}
                onClick={e => { e.preventDefault(); addToCart(pro); }}
                disabled={isAdding}
              >
                {isAdding
                  ? <><span className="hm2-btn-spinner" />Ajout…</>
                  : isAdded
                  ? <><i className="bi bi-check-lg" />Ajouté</>
                  : <><i className="bi bi-cart-plus" />Panier</>}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  const SuivantBtn = () => (
    <div className="hm2-more-wrap">
      <button className="hm2-more" onClick={handleSuivant} disabled={loadingMore}>
        {loadingMore
          ? <><span className="hm2-spin-sm" />Chargement…</>
          : <><i className="bi bi-arrow-down-circle" />Suivant</>}
      </button>
    </div>
  );

  if (loading) return (
    <div className="hm2-root">
      <NewSideBarMagasins />
      <div className="hm2-loading">
        <span className="hm2-spin-lg" />
        <span className="hm2-loading-txt">Chargement…</span>
      </div>
    </div>
  );

  const sidebarContent = (
    <>
      <p className="hm2-sb-head">Catégories</p>
      {visibleCats.map(cat => (
        <label key={cat} className={`hm2-sb-row${selCat === cat ? " hm2-sb-active" : ""}`}>
          <input type="checkbox" checked={selCat === cat} onChange={() => { fetchCat(cat); setShowOtherInput(false); }} />
          <span className="hm2-sb-check" /><span>{cat}</span>
        </label>
      ))}
      <button
        onClick={() => setShowOtherInput(!showOtherInput)}
        style={{ background: "none", border: "none", color: "#666", fontSize: 13, cursor: "pointer", textAlign: "left", width: "100%", padding: "8px 0", fontWeight: 600 }}
      >
        {showOtherInput ? "Masquer Autre ▲" : "Autre ▼"}
      </button>
      {showOtherInput && (
        <div style={{ marginTop: 8, paddingRight: 10 }}>
          <input
            type="text"
            placeholder="tape une categorie"
            value={otherCategory}
            onChange={(e) => setOtherCategory(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && otherCategory.trim() !== "") fetchCat(otherCategory.trim());
            }}
            style={{ width: "100%", padding: "6px 10px", borderRadius: 8, border: "1px solid #ddd", outline: "none", fontSize: 13, boxSizing: "border-box", color: "#111", background: "#fff" }}
          />
          <button
            onClick={() => {
              if (otherCategory.trim() !== "") fetchCat(otherCategory.trim());
            }}
            style={{ marginTop: 8, width: "100%", background: "#000", color: "#fff", border: "none", borderRadius: 8, padding: "6px", fontSize: 13, cursor: "pointer" }}
          >
            Filtrer
          </button>
        </div>
      )}
      <p className="hm2-sb-head" style={{ marginTop: 20 }}>
        <i className="bi bi-funnel-fill" /> Filtrer par magasin
      </p>
      {[
        { v: "tout les produits",        l: "Tous les produits" },
        { v: "Mes Produits",             l: "Mes Produits" },
      ].map(({ v, l }) => (
        <label key={v} className={`hm2-sb-row${shopFilter === v ? " hm2-sb-active" : ""}`}>
          <input type="checkbox" checked={shopFilter === v} onChange={() => setShopFilter(v)} />
          <span className="hm2-sb-check" /><span>{l}</span>
        </label>
      ))}

      {/* ── Options de Tri & Stock ── */}
      <p className="hm2-sb-head" style={{ marginTop: 20 }}>
        <i className="bi bi-sliders" /> Tri &amp; Disponibilité
      </p>
      <button
        className={`hm2-filter-toggle${filterMoinsCher ? " hm2-filter-toggle-on" : ""}`}
        onClick={() => setFilterMoinsCher(v => !v)}
      >
        <span className="hm2-ft-icon"><i className="bi bi-graph-down-arrow" /></span>
        <span className="hm2-ft-body">
          <span className="hm2-ft-title">Moins chers</span>
          <span className="hm2-ft-sub">Trier par prix croissant</span>
        </span>
        <span className="hm2-ft-check">
          <i className={`bi ${filterMoinsCher ? "bi-check-circle-fill" : "bi-circle"}`} />
        </span>
      </button>
      <button
        className={`hm2-filter-toggle${filterDisponible ? " hm2-filter-toggle-on" : ""}`}
        onClick={() => setFilterDisponible(v => !v)}
      >
        <span className="hm2-ft-icon"><i className="bi bi-box-seam" /></span>
        <span className="hm2-ft-body">
          <span className="hm2-ft-title">En stock</span>
          <span className="hm2-ft-sub">Articles disponibles</span>
        </span>
        <span className="hm2-ft-check">
          <i className={`bi ${filterDisponible ? "bi-check-circle-fill" : "bi-circle"}`} />
        </span>
      </button>
    </>
  );

  const enCompteActive = localStorage.getItem("en_compte_active") === "1";
  const enCompteSupplierName = localStorage.getItem("en_compte_supplier_name") || "";
  const enCompteSolde = localStorage.getItem("en_compte_solde") || "0";

  const EnCompteBanner = () => {
    if (enCompteActive) {
      return (
        <div
          style={{
            background: "linear-gradient(90deg, #1e293b 0%, #0f172a 100%)",
            color: "#ffffff",
            padding: "10px 18px",
            borderRadius: "14px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            flexWrap: "wrap",
            boxShadow: "0 4px 14px rgba(15, 23, 42, 0.12)",
            border: "1px solid rgba(245, 158, 11, 0.3)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
              style={{
                background: "#d97706",
                color: "#fff",
                padding: "3px 8px",
                borderRadius: "6px",
                fontSize: "11px",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              En Compte Actif
            </span>
            <span style={{ fontSize: "13px", fontWeight: 500 }}>
              Fournisseur : <strong>{enCompteSupplierName}</strong>
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <span style={{ fontSize: "13px", color: "#cbd5e1" }}>
              Solde :{" "}
              <strong style={{ color: "#34d399", fontSize: "14px" }}>
                {parseFloat(enCompteSolde).toLocaleString("fr-FR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                MAD
              </strong>
            </span>
            {/* Hide Quitter le mode for fournisseur magasins — they manage clients, not suppliers */}
            {!isFournisseur && (
              <button
                onClick={() => {
                  localStorage.removeItem("en_compte_active");
                  localStorage.removeItem("en_compte_supplier_id");
                  localStorage.removeItem("en_compte_supplier_name");
                  localStorage.removeItem("en_compte_solde");
                  window.location.reload();
                }}
                style={{
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#fff",
                  borderRadius: "6px",
                  padding: "4px 10px",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                Quitter le mode
              </button>
            )}
          </div>
        </div>
      );
    }

    if (enCompteSuppliers && enCompteSuppliers.length > 0) {
      const firstSup = enCompteSuppliers[0];
      return (
        <div
          style={{
            background: "linear-gradient(90deg, #fffbeb 0%, #fef3c7 100%)",
            color: "#92400e",
            padding: "10px 18px",
            borderRadius: "14px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            flexWrap: "wrap",
            boxShadow: "0 2px 8px rgba(217, 119, 6, 0.08)",
            border: "1px solid #fde68a",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
              style={{
                background: "#d97706",
                color: "#fff",
                padding: "3px 8px",
                borderRadius: "6px",
                fontSize: "11px",
                fontWeight: 700,
                textTransform: "uppercase",
              }}
            >
              Mode En Compte Disponible
            </span>
            <span style={{ fontSize: "13px", fontWeight: 600 }}>
              Vous êtes en compte avec {enCompteSuppliers.length > 1 ? `${enCompteSuppliers.length} fournisseurs` : <strong>{firstSup.NomMagasin}</strong>} (Solde : {parseFloat(String(firstSup.solde || 0)).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MAD)
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              onClick={() => {
                localStorage.setItem("en_compte_active", "1");
                localStorage.setItem("en_compte_supplier_id", String(firstSup.magasin_id));
                localStorage.setItem("en_compte_supplier_name", firstSup.NomMagasin || "");
                localStorage.setItem("en_compte_solde", String(firstSup.solde || "0"));
                window.location.reload();
              }}
              style={{
                background: "#d97706",
                border: "none",
                color: "#fff",
                borderRadius: "6px",
                padding: "5px 12px",
                fontSize: "12px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <i className="bi bi-power" style={{ marginRight: 4 }} />
              Activer le mode ({firstSup.NomMagasin})
            </button>
            <a
              href={`/magasins/${id}/en-compte`}
              style={{
                fontSize: "12px",
                color: "#92400e",
                fontWeight: 600,
                textDecoration: "underline",
              }}
            >
              Voir détails
            </a>
          </div>
        </div>
      );
    }

    return null;
  };

  /* ═════════════════════════════════════════════════════
     MOBILE
  ═════════════════════════════════════════════════════ */
  if (screenW <= 768) return (
    <div className="hm2-root">
      <NewSideBarMagasins />
      {toast.show && (
        <ColisToast msg={toast.msg} active={toast.on}
          onClose={() => setToast(t => ({ ...t, show: false }))} />
      )}
      <div className="hm2-mob-header">
        <EnCompteBanner />
        <div className="hm2-mob-search-row">
          <div className="hm2-mob-search">
            <i className="bi bi-search" onClick={triggerSearch} />
            <input type="text" value={searchInput}
              onChange={handleSearchInputChange}
              onKeyDown={handleSearchKeyDown}
              placeholder="Chercher un produit…" />
            {searchInput && <button onClick={resetToDefault}><i className="bi bi-x" /></button>}
          </div>
          <button className="hm2-mob-filter-btn" onClick={() => setFilterOpen(v => !v)}>
            <i className="bi bi-sliders" />
          </button>
        </div>
        <ColisBanner active={colisOn} loading={colisLd} onToggle={toggleColis} />
        {/* ── Mobile quick-filter bar ── */}
        <div className="hm2-mob-filterbar">
          <button
            className={`hm2-mob-ftbtn${filterMoinsCher ? " hm2-mob-ftbtn-on" : ""}`}
            onClick={() => setFilterMoinsCher(v => !v)}
          >
            <i className="bi bi-graph-down-arrow" />
            <span>Moins chers</span>
          </button>
          <button
            className={`hm2-mob-ftbtn${filterDisponible ? " hm2-mob-ftbtn-on" : ""}`}
            onClick={() => setFilterDisponible(v => !v)}
          >
            <i className="bi bi-box-seam" />
            <span>En stock</span>
          </button>
        </div>
      </div>
      <FilterMagasin isOpen={filterOpen} onClose={() => setFilterOpen(false)}
        selectedFilterDistance={distFilter} setSelectedFilterDistabce={setDistFilter}
        selectedFilter={shopFilter} setSelectedFilter={setShopFilter} />
      {list.length > 0 ? (
        <>
          <div className="hm2-mob-grid">
            {list.map(pro => {
              const link = `/magasins/${id}/${pro.NomMagasin || MagasinName}/articles/${btoa(pro.RefArticle)}`;
              return <Card key={pro.IdArticle ?? pro.id} pro={pro} linkTo={link} />;
            })}
          </div>
          {hasMore && <SuivantBtn />}
        </>
      ) : (
        <div className="hm2-empty"><i className="bi bi-search" /><p>Aucun produit trouvé</p></div>
      )}
    </div>
  );

  /* ═════════════════════════════════════════════════════
     DESKTOP
  ═════════════════════════════════════════════════════ */
  return (
    <div className="hm2-root">
      <NewSideBarMagasins />
      {toast.show && (
        <ColisToast msg={toast.msg} active={toast.on}
          onClose={() => setToast(t => ({ ...t, show: false }))} />
      )}
      <div className="hm2-desktop">
        <EnCompteBanner />
        <div className="hm2-toolbar">
          <div className="hm2-search">
            <i className="bi bi-search hm2-search-ico" onClick={triggerSearch} />
            <input type="text" value={searchInput}
              onChange={handleSearchInputChange}
              onKeyDown={handleSearchKeyDown}
              placeholder="Rechercher un produit, référence…" />
            {searchInput.trim().length > 0 && (
              <button className="hm2-search-clr" onClick={resetToDefault}>
                <i className="bi bi-x-lg" />
              </button>
            )}
          </div>
          <div className="hm2-sort">
            <i className="bi bi-arrow-down-up hm2-sort-ico" />
            <select value={distFilter} onChange={e => setDistFilter(e.target.value)}>
              <option value="">Trier : Tous</option>
              <option value="par parent">Par proximité</option>
            </select>
          </div>
          <ColisBanner active={colisOn} loading={colisLd} onToggle={toggleColis} />
        </div>

        <div className="hm2-chips">
          {selCat && selCat !== "Tous" && (
            <span className="hm2-chip">
              {selCat}
              <button onClick={handleClearCategory}>
                <i className="bi bi-x" />
              </button>
            </span>
          )}
          {search && (
            <span className="hm2-chip">
              "{search}"
              <button onClick={resetToDefault}><i className="bi bi-x" /></button>
            </span>
          )}
          <span className="hm2-count">
            <b>{list.length}</b> résultat{list.length !== 1 ? "s" : ""}
          </span>
        </div>

        <div className="hm2-layout">
          <aside className="hm2-sidebar">{sidebarContent}</aside>
          <main className="hm2-main">
            {list.length > 0 ? (
              <>
                <div className="hm2-grid">
                  {list.map(pro => {
                    const link = `/magasins/${id}/${pro.NomMagasin || MagasinName}/articles/${btoa(pro.RefArticle)}`;
                    return <Card key={pro.IdArticle ?? pro.id} pro={pro} linkTo={link} />;
                  })}
                </div>
                {hasMore && <SuivantBtn />}
              </>
            ) : (
              <div className="hm2-empty">
                <i className="bi bi-search" /><p>Aucun produit trouvé</p>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}